import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { PlusIcon, MinusIcon } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    q: '¿Es para mí si tengo más de 50 años?',
    a: 'H.E.R. está pensado para mujeres de 35 a 54 años. Si tenés más de 50 o dudas sobre tu caso, consultá con tu profesional antes de empezar.'
  }, {
    q: '¿Necesito ingredientes especiales o costosos?',
    a: 'No. La base del protocolo se arma con ingredientes de supermercado: huevos, carnes/pescado accesibles, verduras de estación, legumbres, arroz/quinoa según fase, yogur natural y semillas. Además, incluimos una Guía de Compras Argentina (versión económica + sustituciones) para que lo adaptes a tu presupuesto.'
  }, {
    q: '¿Tengo que hacer ejercicio extremo?',
    a: 'No. Las rutinas duran entre 15 y 25 minutos, se hacen en casa y no necesitás gimnasio ni equipos costosos.'
  }, {
    q: '¿Y si no es lo que esperaba?',
    a: 'Garantía de 30 días. Si H.E.R. no es para vos, te devolvemos el 100% de tu dinero.'
  }, {
    q: '¿Qué pasa después de los 21 días?',
    a: 'H.E.R. incluye una guía de continuidad para llevar lo trabajado durante el programa a las semanas siguientes, con una estructura de referencia para los días 22 a 28.'
  }, {
    q: '¿Es para mí si estoy en menopausia?',
    a: 'Está pensado para la etapa de transición hacia la menopausia: propone hábitos de comida, movimiento y descanso. No es un tratamiento médico; si tenés síntomas que te preocupan o usás medicación, consultá con tu profesional.'
  }, {
    q: '¿Es seguro si tengo condiciones médicas?',
    a: 'H.E.R. es un programa educativo de hábitos y no reemplaza la consulta médica. Si tenés una condición médica, tomás medicación o estás amamantando, consultá con tu profesional antes de empezar.'
  }];
  return <section className="bg-gradient-hero py-12 md:py-16 px-4 md:px-8" style={{
    paddingTop: "0px"
  }} data-id="element-94" data-mp="u0xjo0stm1jp">
      <div className="max-w-3xl mx-auto space-y-12" style={{
      paddingTop: "22px"
    }} data-id="element-95" data-mp="p35ieg6ad32u">
        {/* Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center space-y-4" data-id="element-96" data-mp="2p5x0bxp8x89j">
          <h2 className="text-4xl md:text-5xl font-display font-black" data-id="element-97" data-mp="333d8per3rc3x">
            Preguntas <span className="text-gradient-gold" data-id="element-98" data-mp="3318w88f514s1">Frecuentes</span>
          </h2>
        </motion.div>

        {/* Accordions */}
        <div className="space-y-4" data-id="element-99" data-mp="3d19hhzwkhuyv">
          {faqs.map((faq, i) => <FAQItem key={i} faq={faq} index={i} data-id="element-100" data-mp="3czoo4dlzoi2l" data-mpi={i} />)}
        </div>
      </div>
    </section>;
}
function FAQItem({
  faq,
  index
}: {
  faq: {
    q: string;
    a: string;
  };
  index: number;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} transition={{
    duration: 0.5,
    delay: index * 0.1
  }} className="card-premium overflow-hidden" data-id="element-101" data-mp="3qtfu5c0ihjtk">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full flex items-center justify-between p-5 md:p-6 text-left hover:bg-white/[0.02] transition-colors" data-id="element-102" data-mp="1k68hu647yskh">
        <span className="font-body font-semibold text-base md:text-lg text-foreground flex items-start md:items-center gap-3 leading-snug" data-id="element-103" data-mp="1b37cw8r3b7ie">
          <span className="text-xl mt-0.5 md:mt-0" data-id="element-104" data-mp="166qn7a48sl37">❓</span> {faq.q}
        </span>
        <span className="text-secondary flex-shrink-0 ml-4" data-id="element-105" data-mp="22tve1ksrkcw2">
          {isOpen ? <MinusIcon className="w-6 h-6" data-id="element-106" data-mp="1yt1raur2544r" /> : <PlusIcon className="w-6 h-6" data-id="element-107" data-mp="1yu3axnm52yy3" />}
        </span>
      </button>

      <AnimatePresence data-id="element-108" data-mp="1u21urqluoo2s">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3
      }} data-id="element-109" data-mp="1u10hrgl9xrif">
            <div className="px-5 md:px-6 pb-6 pt-2 text-foreground/80 font-body text-[15px] md:text-base font-medium flex items-start gap-3 border-t border-border/50 mt-2 leading-relaxed" data-id="element-110" data-mp="2hrw3px31tshr">
              <span className="text-xl mt-1" data-id="element-111" data-mp="26bri1x5dku8e">✅</span>
              <p className="pt-1" data-id="element-112" data-mp="26dkp3djwhggx">{faq.a}</p>
            </div>
          </motion.div>}
      </AnimatePresence>
    </motion.div>;
}